import actions from '../actions/batches';

const initialState: any = {
    loading: false,
    errorModal: {
        isOpen: false,
        rowId: ''
    },
    filters: {
        page: 1,
        items_per_page: 25,
        order: 'date_created',
        order_direction: 'desc'
    },
    selected: {},
    multiSelected: [],
    data: {},
    error: {}
};

const batchesList = (state = initialState, action): any => {
    switch (action.type) {
        case actions.SET_ERROR_MODAL:
            return {
                ...state,
                errorModal: {
                    ...state.errorModal,
                    ...{ isOpen: action.toggle, rowId: action.id }
                }
            };
        case actions.SET_LOADING:
            return {
                ...state,
                loading: action.toggle
            };
        case actions.FILTER:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.filters
                }
            };
        case actions.CLEAR_FILTERS:
            return {
                ...state,
                filters: { ...initialState.filters }
            };
        case actions.SELECT:
            return {
                ...state,
                selected: { ...action.selectedBatch },
                multiSelected: []
            };
        case actions.MULTI_SELECT:
            return {
                ...state,
                selected: {},
                multiSelected: action.selectedBatches
            };
        case actions.SEED_ID:
            return {
                ...state,
                selected: { id: action.batchId }
            };
        case actions.UPDATE_NAME:
            return {
                ...state,
                data: {
                    ...state.data,
                    batches: state.data.batches.map((b: any) => {
                        if (b.id === action.batchId) {
                            return { ...b, name: action.name };
                        }

                        return b;
                    })
                }
            };
        case actions.FORCE_ROWS_RENDERED:
            return {
                ...state,
                data: {
                    ...state.data,
                    batches: state.data.batches.map((b: any) => {
                        if (b.id === action.batchId) {
                            return { ...b, rowsRendered: action.rowsRendered };
                        }

                        return b;
                    })
                }
            };
        case actions.FORCE_RENDER_STATUS:
            return {
                ...state,
                data: {
                    ...state.data,
                    batches: state.data.batches.map((b: any) => {
                        if (b.id === action.batchId) {
                            return { ...b, status: action.forcedRenderStatus };
                        }

                        return b;
                    })
                }
            };
        case actions.UPDATE_TOTAL_ROWS:
            return {
                ...state,
                selected: {
                    ...state.selected,
                    total_rows: action.total
                },
                data: {
                    ...state.data,
                    batches: state.data.batches.map((b: any) => {
                        if (b.id === action.batchId) {
                            return { ...b, total_rows: action.total };
                        }

                        return b;
                    })
                }
            };
        case actions.GET:
            return {
                ...state,
                data: { ...action.batches }
            };
        case actions.DELETE:
            return {
                ...state,
                selected: {}
            };
        case actions.ERROR: {
            return {
                ...state,
                error: { ...state.error, [action.error.id]: { ...action.error } }
            };
        }
        default:
            return state;
    }
};

export default batchesList;
